//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name: 'GlasgowSystem',
  data () {
    return {
      form: {
        answer1: '0',
        answer2: '0',
        answer3: '0',
        answer4: '0',
        answer5: '0',
        answer6: '0',
        answer7: '0',
        answer8: '0'
      },
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result = form.answer1 + form.answer2 + form.answer3 + form.answer4 + form.answer5 + form.answer6 + form.answer7 + form.answer8
        if (result < 3) {
          self.descTxt = '不考虑重症胰腺炎 '
        } else if (result > 3 || result === 3) {
          self.descTxt = '考虑重症胰腺炎'
        }
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/GlasgowSystem.vue